import React, { Component } from 'react'
import PropTypes from 'prop-types'
import AppStore from '../../store/AppStore'
import { push } from 'react-router-redux'
import { PATH_ADMINISTRATION_ACCOUNT, PATH_ADMINISTRATION_THEME, PATH_HOME, PATH_RESEARCH, PATH_SELECTION } from '../constants/HomeConstants'
import SiteAction from '../../sites/actions/SitesAction'
import { aquasysPath } from '../../conf/basepath'
import DtoUser from '../dto/DtoUser'
import HomeAction from '../actions/HomeAction'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'

class SideNav extends Component {

	getEmail = () => {
		if (this.props.user && this.props.user.email) {
			return (
				<span className='white-text email'>{ this.props.user.email }</span>
			)
		}
		return ''
	}

	logout = () => {
		AppStore.dispatch(HomeAction.logout())
	}

	goTo = (path) => {
		AppStore.dispatch(SiteAction.reset())
		AppStore.dispatch(push(path))
	}
	goToExternalLink = (path) => {
		window.open(path, '_blank')
	}

	render() {
		if (this.props.isLogged) {
			return (
				<ul id='slide-out' className='side-nav'>
					<li>
						<div className='userView'>
							<div className='background'/>
							<div className='center-align'>
								<img className='logo ' src={ `${ aquasysPath }/wp-content/uploads/2018/01/7-1.png` } onClick={ () => this.goTo(PATH_HOME) }/>
							</div>
							<span className='white-text name'>{ this.props.user.login }</span>
							{ this.getEmail() }
						</div>
					</li>
					<div className='collection'>
						<a className='collection-item text-icon-align' onClick={ () => this.goTo(PATH_HOME) }>
							<i className='material-icons font-grey padding-right-20'>home</i>{ i18n.home }
						</a>
					</div>
					<div className='collection'>
						<a className='collection-item text-icon-align' onClick={ () => this.goTo(`${ PATH_RESEARCH }/open`) }>
							<i className='material-icons font-grey padding-right-20'>map</i>{ i18n.map }
						</a>
					</div>
					<div className='collection'>
						<a className='collection-item text-icon-align' onClick={ () => this.goTo(PATH_SELECTION) }>
							<i className='material-icons font-grey padding-right-20'>list</i>{ i18n.myResearch }
						</a>
					</div>
					<div className='divider'/>
					<div className='collection'>
						<a className='collection-item text-icon-align' onClick={ () => this.goTo(PATH_ADMINISTRATION_ACCOUNT) }>
							<i className='material-icons font-grey padding-right-20'>person</i>{ i18n.myAccount }
						</a>
					</div>
					<div className='divider'/>
					<div className='collection'>
						<a className='collection-item text-icon-align' onClick={ () => this.goTo(PATH_ADMINISTRATION_THEME) }>
							<i className='material-icons font-grey padding-right-20'>view_quilt</i>{ i18n.dataSource }
						</a>
					</div>
					<div className='collection'>
						<a className='collection-item text-icon-align' onClick={ () => this.goToExternalLink(`${ aquasysPath }/legal`) }>
							<i className='material-icons font-grey padding-right-20'>help</i>{ i18n.legalNotice }
						</a>
					</div>
					<div className='collection'>
						<a className='collection-item text-icon-align' onClick={ () => this.goToExternalLink(`${ aquasysPath }/legal`) }>
							<i className='material-icons font-grey padding-right-20'>help</i>{ i18n.cglu }
						</a>
					</div>
					<div className='divider'/>
					<div className='collection'>
						<a className='collection-item text-icon-align' onClick={ () => this.logout() }>
							<i className='material-icons font-grey padding-right-20'>power_settings_new</i>{ i18n.signOut }
						</a>
					</div>
					<div className='bottom-nav' style={ { marginTop: '100%' } }>
						<div className='link no-margin center-align' style={ { paddingTop: '15%' } }>
							<a href='http://www.aquasys.fr/actualites/' target='_blank' className='no-style'>{ i18n.news }</a>
						</div>
						<div className='row no-margin'>
							<div className='col s4 offset-s2 center-align'>
								<a href='http://www.ademe.fr' target='_blank'>
									<img src={ `${ aquasysPath }/wp-content/uploads/2018/01/1-2.png` } alt='logo ADEME' width='50px' className='z-depth-1'/>
								</a>
							</div>
							<div className='col s4 center-align padding-bottom-10'>
								<img src={ `${ aquasysPath }/wp-content/uploads/2018/01/4-2.png` } alt='logo PIA' width='50px'/>
							</div>
						</div>
					</div>
				</ul>
			)
		}
		return null
	}

	componentDidMount() {
		$('.collapsible').collapsible()
	}
}

SideNav.propTypes = {
	user: PropTypes.objectOf(DtoUser),
	isLogged: PropTypes.bool
}
SideNav.defaultProps = {
	isLogged: false
}
const mapStateToProps = store => {
	return {
		user: store.HomeReducer.user
	}
}
export default connect(mapStateToProps)(SideNav)



// WEBPACK FOOTER //
// ./src/home/components/SideNav.js